// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"map-distance"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M21 3H3V21H21V3Z"}},{"tag":"g","attrs":{"id":"fill2"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M18 7.5C18 8.71875 16.5 9.75 16.5 9.75C16.5 9.75 15 8.71861 15 7.5C15 6.67157 15.6716 6 16.5 6C17.3284 6 18 6.67157 18 7.5Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M10 10.5C10 11.7188 8.5 12.75 8.5 12.75C8.5 12.75 7 11.7186 7 10.5C7 9.67157 7.67157 9 8.5 9C9.32843 9 10 9.67157 10 10.5Z"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21 3H3V21H21V3Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M14.5 14.5L18.5 13M6.5 17.5L10.5 16M18 7.5C18 8.71875 16.5 9.75 16.5 9.75C16.5 9.75 15 8.71861 15 7.5C15 6.67157 15.6716 6 16.5 6C17.3284 6 18 6.67157 18 7.5ZM10 10.5C10 11.7188 8.5 12.75 8.5 12.75C8.5 12.75 7 11.7186 7 10.5C7 9.67157 7.67157 9 8.5 9C9.32843 9 10 9.67157 10 10.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const MapDistanceIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'map-distance',
    ref,
    icon: element,
  },
));

MapDistanceIcon.displayName = 'MapDistanceIcon';

export default MapDistanceIcon;
